import 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jquery-ajax-unobtrusive';

(function ($) {
    "use strict";
    var defaultOptions = {
        validClass: '',
        errorClass: 'has-error',
        highlight: function (element, errorClass, validClass) {
            $(element)
                .closest(".input, .checkbox, .select")
                .removeClass(validClass)
                .addClass(errorClass);
        },
        unhighlight: function (element, errorClass, validClass) {
            $(element)
                .closest(".input, .checkbox, .select")
                .removeClass(errorClass)
                .addClass(validClass);
        },
        ignore: ':hidden:not(:checkbox)'
    };

    $.validator.setDefaults(defaultOptions);

    $.validator.unobtrusive.options = {
        errorClass: defaultOptions.errorClass,
        validClass: defaultOptions.validClass
    };

    // Checkbox is checked validator
    $.validator.addMethod('mustbetrue',
        function (value, element, params) {
            return element.checked;
        });

    // dawa address validator
    $.validator.addMethod('dawaaddress',
        function (value, element, params) {
            if (params.streetinput === '' || params.zipcodeinput === '' || params.cityinput === '') {
                return false;
            }

            var street = element.dataset.valStreet;
            var zipCode = element.dataset.valZipcode;
            var city = element.dataset.valCity;

            if ((street === '' || street === undefined) || (zipCode === '' || zipCode === undefined ) || (city === '' || city === undefined)) {
                return false;
            }

            return true;
        });

    $.validator.unobtrusive.adapters.add('mustbetrue', [], function (options) {
        options.rules['mustbetrue'] = true;
        options.messages['mustbetrue'] = options.message;
    });

    $.validator.unobtrusive.adapters.add('dawaaddress', ['streetinput', 'zipcodeinput', 'cityinput'], function (options) {
        options.rules['dawaaddress'] = options.params;
        options.messages['dawaaddress'] = options.message;
    });
})(jQuery);